import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandingComponent } from './branding/branding.component';
import { BrandingsListComponent } from './brandings-list/brandings-list.component';
import { BrandingsScalesListComponent } from './brandings-scales-list/brandings-scales-list.component';
import { BrandingApiService } from './services/branding-api.service';
import { MaterialModule } from '@app/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [CommonModule, MaterialModule, TranslateModule, FormsModule, ReactiveFormsModule, SharedModule],
  declarations: [BrandingComponent, BrandingsListComponent, BrandingsScalesListComponent],
  providers: [BrandingApiService],
  exports: [BrandingComponent]
})
export class BrandingModule {}



// WEBPACK FOOTER //
// ./src/app/branding/branding.module.ts